import { Image } from "react-bootstrap";
import { CopertureAggiuntiveImage, NovitaImage } from "src/assets";
import { useSection3 } from "./section3.hook";

interface Subtitle {
  text: string;
  style?: string;
}

interface Description {
  text: string;
  isNew?: boolean;
}

export const Section3 = () => {
  const { t } = useSection3();

  const TextSection = ({
    title,
    subtitles,
    descriptions,
  }: {
    title: string;
    subtitles: Subtitle[];
    descriptions: Description[];
  }) => (
    <div
      className="col-12 col-lg-10 d-flex align-items-start h-100"
      style={{ minWidth: 0 }}
    >
      <div className="w-100">
        <h2 className="text-start font-48-light c-292929">{title}</h2>
        <div className="mt-2 align-items-center text-start">
          {descriptions.map((desc, index) => (
            <div key={index} className="mb-2">
              <div className={`font-18-bold c-646464 ${subtitles[index].style}`}>
                {subtitles[index].text}
              </div>
              {desc.isNew && (
                <sup className="text-uppercase bg-7c2d35 c-ffffff font-12-bold d-inline-block px-2 ms-2">
                  {t("commons.new")}
                </sup>
              )}
              <div className="font-18 c-646464">{desc.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="container-fluid">
      <div className="d-flex flex-column flex-lg-row w-100 mb-5 pb-lg-5">
        <div className="col-12 col-lg-6 pe-lg-5">
          <TextSection
            title={t("landing.section3_2.title")}
            subtitles={[
              {
                text: t("landing.section3_2.subtitle_new1"),
                style: "font-18-light fw-bold mb-4",
              },
              { text: t("landing.section3_2.subtitle_new2") },
              { text: t("landing.section3_2.subtitle_new4") },
              { text: t("landing.section3_2.subtitle_new5"),
                style: "font-18-light fw-bold mb-4 mt-4 pt-2 pb-2"
               },
              { text: t("landing.section3_2.subtitle2") },
              { text: t("landing.section3_2.subtitle3") },
              { text: t("landing.section3_2.subtitle4") },
              { text: t("landing.section3_2.subtitle1") },
            ]}
            descriptions={[
              { text: t("landing.section3_2.description_new1") },
              { text: t("landing.section3_2.description_new2") },
              { text: t("landing.section3_2.description_new4") },
              { text: t("landing.section3_2.description_new5") },
              { text: t("landing.section3_2.description2") },
              { text: t("landing.section3_2.description3") },
              { text: t("landing.section3_2.description4") },
              { text: t("landing.section3_2.description1") },
            ]}
          />
        </div>
        <div className="col-12 col-lg-6">
          <Image src={NovitaImage} fluid className="w-100 h-auto" />
        </div>
      </div>

      <div className="d-flex flex-column-reverse flex-lg-row w-100 pb-lg-5">
        <div className="col-12 col-lg-6 me-lg-5">
          <Image
            src={CopertureAggiuntiveImage}
            fluid
            className="w-100 h-auto"
          />
        </div>
        <div className="col-12 col-lg-6">
          <TextSection
            title={t("landing.section3.title")}
            subtitles={[
              { text: t("landing.section3.subtitle1") },
              { text: t("landing.section3.subtitle2") },
              { text: t("landing.section3.subtitle3") },
              { text: t("landing.section3_2.subtitle5") },
            ]}
            descriptions={[
              { text: t("landing.section3.description1") },
              { text: t("landing.section3.description2") },
              { text: t("landing.section3.description3") },
              { text: t("landing.section3_2.description5") },
            ]}
          />
        </div>
      </div>

      <p className="font-24 c-646464">{t("landing.section3.footer")}</p>
    </div>
  );
};
